import { render, staticRenderFns } from "./OnboardingFooter.vue?vue&type=template&id=3df75421&scoped=true"
import script from "./OnboardingFooter.vue?vue&type=script&lang=ts"
export * from "./OnboardingFooter.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingFooter.vue?vue&type=style&index=0&id=3df75421&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df75421",
  null
  
)

export default component.exports